<!--线索联系人下拉选择器-->
<template>
    <el-autocomplete
        size="small"
        v-model="ContactIds"
        :fetch-suggestions="querySearchAsync"
        placeholder="请输入关键词"
        @select="handleChange"
        @blur="handleBlur">
        <template slot-scope="{ item }">
            <div class="label" :title="item.value" >{{ item.value }}</div>
        </template>
    </el-autocomplete>
</template>

<script>
import CommonService from "~/services/common";

export default {
    name: "ContactClueSelect",
    data() {
        return {
            ContactIds: null
        };
    },
    methods: {

        querySearchAsync(queryString, cb) {
            let qs = (queryString || '').toString().trim() || undefined;
            let params = {
                fields: 'id,contact_name',
                contact_name: qs
            };
            CommonService.getSaleLeads(params).then(res => {
                if (!res.data) return;
                let results = res.data.filter(item => {
                    if (!qs) return true;
                        return item.contact_name.toString().indexOf(qs)> -1;
                }).map( item => {
                    return { 
                        value: item.contact_name, 
                        label: item.id 
                    };
                });
                cb(results)
            });
        },

        handleChange(item) {
            this.$emit("change", item.value);
        },

        handleBlur($event) {
            this.$emit("change", $event.target.value);
        },
        reset() {
            this.ContactIds = '';
        }        
    }
}



</script>


// WEBPACK FOOTER //
// src/widgets/ClueContactSelect.vue